export const licuador1CompGaugeConfig = [
  {
    key: "presSuccion",
    title: "Presión Succión",
    unit: "psi",
    ranges: [
      { min: 21, max: 29.99, color: "green" },
      { min: 18, max: 20.99, color: "yellow" },
      { min: 30, max: 34.99, color: "yellow" },
      { min: 0,  max: 17.99, color: "red" },
      { min: 35, max: 1000, color: "red" },
    ],
  },

  {
    key: "presDescarga",
    title: "Presión Descarga",
    unit: "psi",
    ranges: [
      { min: 156, max: 195.99, color: "green" },
      { min: 140, max: 155.99, color: "yellow" },
      { min: 196, max: 209.99, color: "yellow" },
      { min: 0,   max: 139.99, color: "red" },
      { min: 210, max: 350000, color: "red" },
    ],
  },

  {
  key: "tempRefrEvap",
  title: "Temp. Refr Evap",
  unit: "°C",
  ranges: [
      { min: -26, max: 0, color: "green" },
      { min: -28, max: -26, color: "yellow" },
      { min: 0, max: 5, color: "yellow" },
      { min: -40, max: -28, color: "red" },
      { min: 5, max: 3000, color: "red" },
    ],
  },

  {
    key: "tempProcesoEntrada",
    title: "Temp. Proceso Entrada",
    unit: "°C",
    ranges: [
      { min: 25, max: 34.99, color: "green" },
      { min: 35, max: 39.99, color: "yellow" },
      { min: 20, max: 24.99, color: "yellow" },
      { min: 0,  max: 19.99, color: "red" },
      { min: 40, max: 10000, color: "red" },
    ],
  },

  {
    key: "tempProcesoSalida",
    title: "Temp. Proceso Salida",
    unit: "°C",
    ranges: [
      { min: -22, max: -16.99, color: "green" },
      { min: -24, max: -21.99, color: "yellow" },
      { min: -17, max: -14.99, color: "yellow" },
      { min: -35, max: -23.99, color: "red" },
      { min: -15, max: 0,   color: "red" },
    ],
  },

  {
    key: "tempCondEntrada",
    title: "Temp. Cond Entrada",
    unit: "°C",
    ranges: [
      { min: 32, max: 39.99, color: "green" },
      { min: 25, max: 31.99, color: "yellow" },
      { min: 40, max: 49.99, color: "yellow" },
      { min: 0,  max: 24.99, color: "red" },
      { min: 50, max: 20000, color: "red" },
    ],
  },

  {
    key: "tempCondSalida",
    title: "Temp. Cond Salida",
    unit: "°C",
    ranges: [
      { min: 32, max: 38.99, color: "green" },
      { min: 25, max: 31.99, color: "yellow" },
      { min: 39, max: 49.99, color: "yellow" },
      { min: 0,  max: 24.99, color: "red" },
      { min: 50, max: 20000, color: "red" },
    ],
  },

  {
    key: "tempDescarga",
    title: "Temp. Descarga",
    unit: "°C",
    ranges: [
      { min: 60, max: 89.99,  color: "green" },
      { min: 40, max: 59.99,  color: "yellow" },
      { min: 90, max: 99.99, color: "yellow" },
      { min: 0,  max: 39.99,  color: "red" },
      { min: 100, max: 20000, color: "red" },
    ],
  },
];
